// Local preferences for the in-app message-notification surface. Both
// values are stored in localStorage and default to OFF — they require
// the user to opt in via the prefs button in the messages inbox.

const SOUND_KEY = 'messaging-prefs-sound-v1';
const BROWSER_NOTIFICATIONS_KEY = 'messaging-prefs-browser-notifications-v1';

const readBool = (key: string): boolean => {
  if (typeof window === 'undefined') return false;
  try {
    return window.localStorage.getItem(key) === '1';
  } catch {
    return false;
  }
};

const writeBool = (key: string, value: boolean) => {
  if (typeof window === 'undefined') return;
  try {
    if (value) window.localStorage.setItem(key, '1');
    else window.localStorage.removeItem(key);
  } catch {
    /* ignore quota / private-mode */
  }
};

export const getSoundEnabled = () => readBool(SOUND_KEY);
export const setSoundEnabled = (v: boolean) => writeBool(SOUND_KEY, v);

export const getBrowserNotificationsEnabled = () => readBool(BROWSER_NOTIFICATIONS_KEY);
export const setBrowserNotificationsEnabled = (v: boolean) =>
  writeBool(BROWSER_NOTIFICATIONS_KEY, v);

export const isNotificationApiSupported = (): boolean =>
  typeof window !== 'undefined' && 'Notification' in window;

export const getNotificationPermission = (): NotificationPermission | 'unsupported' => {
  if (!isNotificationApiSupported()) return 'unsupported';
  return Notification.permission;
};

export const requestNotificationPermission = async (): Promise<NotificationPermission | 'unsupported'> => {
  if (!isNotificationApiSupported()) return 'unsupported';
  if (Notification.permission === 'granted') return 'granted';
  if (Notification.permission === 'denied') return 'denied';
  try {
    const result = await Notification.requestPermission();
    return result;
  } catch {
    return 'denied';
  }
};
